export const AUTH_QUERY_KEYS = {
  default: () => ['auth'] as const,
  generateOtp: () => [...AUTH_QUERY_KEYS.default(), 'generateOtp'] as const,
  verifyOtp: () => [...AUTH_QUERY_KEYS.default(), 'verifyOtp'] as const,
  associateOtp: () => [...AUTH_QUERY_KEYS.default(), 'associateOtp'] as const,
  verifyEmail: () => [...AUTH_QUERY_KEYS.default(), 'verifyEmail'] as const,
  register: () => [...AUTH_QUERY_KEYS.default(), 'register'] as const,
  login: () => [...AUTH_QUERY_KEYS.default(), 'login'] as const,
  logout: () => [...AUTH_QUERY_KEYS.default(), 'logout'] as const,
};
